//@flow
import React from 'react';

import {useTierRestriction, useTierRestrictionActions} from '../utils';
import FeatureRestrictionModal from '../../../elements/TierRestrictionModal/FeatureRestrictionModal';

export default function TierRestrictionModalAlert() {
  const {tierRestrictionModalOpen} = useTierRestriction();

  const {hideTierRestrictionModal} = useTierRestrictionActions();

  return (
    <FeatureRestrictionModal
      open={tierRestrictionModalOpen}
      handleClose={hideTierRestrictionModal}
    />
  );
}
